import { useEffect } from 'react';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { usePopulateBuyerType } from './usePopulateBuyerType';

interface UsePopulateBuyerTypeForCreateProps {
    isCreateMode: boolean;
}

/**
 * Hook to populate buyerType in create mode (when briefId is not provided).
 * This is needed for duplicate flow and other create flows to determine RNC buyer status.
 *
 * @param props.isCreateMode - Whether the drawer is in create mode (true when briefId is undefined)
 */
export const usePopulateBuyerTypeForCreate = ({ isCreateMode }: UsePopulateBuyerTypeForCreateProps) => {
    const { buyerType, createAbortController } = useBriefCreationContext();
    const { populateBuyerType } = usePopulateBuyerType();

    useEffect(() => {
        if (isCreateMode && !buyerType) {
            const abortController = createAbortController();
            void populateBuyerType(abortController);
        }
    }, [isCreateMode, buyerType, populateBuyerType, createAbortController]);
};
